
import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from '../_services/app.common.service';
import { tap, catchError, timeout } from 'rxjs/operators';
import { NotificationService } from '../notifications/toastr-notification.service';
import { of } from 'rxjs';


@Injectable()
export class JtHttpInterceptor implements HttpInterceptor {
   constructor(public common: CommonService, public Notification: NotificationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let setting = JSON.parse(document.getElementById('setting-container')?.getAttribute('data-settings')??"");
    let storageKey = setting.StorageKey;
    request = request.clone();
    if ((request.urlWithParams.toString().indexOf('.json') === -1 && request.urlWithParams.toString().indexOf('autoRequest') === -1)) {
      localStorage.setItem(storageKey + 'lastActivityTime', new Date() + '');
    }
    // timeout(600000),
    return next.handle(request).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse && evt.status === 201) {
          // this part/code will be done later
        }
      }),
      catchError((evt: any) => {
        if (evt instanceof HttpErrorResponse && evt.status === 401) {

          if (evt.error.code == 701) {
             alert('Access Denied');
            //this.Notification.info(this.common.GetTranslation("Common.AccessAlert"));
            //this.common.NavigateToRoute(this.common.RouteUrls.AccessDenied.NoAccess);
             this.common.Loader.hide();

          } else if (evt.error.code == 708) {
            // this.common.ClearLocalStorageOnlogOut();
            window.location.href = 'Login';
          }
          // this.common.Loader.hide();
        }
        return of(evt);
      }));

  }

}
